export * from "./payment-method.component";
